import { EntryTransformer } from '../components/ArticleRichText/entryTransformersMap';
import { ContentfulCarousel, ContentfulCarouselType } from '@jbhi-fi/apis/src/contentful/types';
import { CarouselTransformer } from '@jbhi-fi/components/src/Contentful/transformers/CarouselTransformer';
import { getStoreCurrency } from '../../../../utils/shopify/getStoreCurrency';

export const determineCarouselTransformer = (carousel: ContentfulCarousel): EntryTransformer => {
  const { Component, transformer } = CarouselTransformer.toContentEntryProps(carousel, {
    productTrackingData: {
      descriptor: {
        page: 'STACK',
        currency: getStoreCurrency(),
        group: carousel.fields?.heading,
        category: carousel?.fields?.heading,
      },
      trackingListName: 'stack',
      listPrefix: 'stack',
    },
  });
  const layoutBlockProps: EntryTransformer['layoutBlockProps'] =
    !!carousel?.fields?.type &&
    [ContentfulCarouselType.Merch, ContentfulCarouselType.Chart, ContentfulCarouselType.Video].includes(
      carousel.fields.type
    )
      ? { paddingLeft: { mobile: 0 }, paddingRight: { mobile: 0 } }
      : undefined;

  return { OutputComponent: Component, transformer, layoutBlockProps };
};
